import React from 'react'
import { NavLink } from 'react-router-dom'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'

import { useNotificationsStore } from './stores/notificationsStore'
import './NotificationsNavLink.scss'

/**
 * Sidebar entry for the notifications dashboard.
 *
 * Deliberately a NavLink and not a popover: notifications span every source in
 * the app, so they get a destination of their own rather than a dropdown
 * hanging off whichever section you happen to be in.
 */
export const NotificationsNavLink = () => {
    const unreadCount = useNotificationsStore((s) => s.summary.unread_count)

    return (
        <NavLink
            to="/notifications"
            className={({ isActive, isPending, isTransitioning }) =>
                [
                    'navlink',
                    'notif-navlink',
                    isPending ? 'pending' : '',
                    isActive ? 'active' : '',
                    isTransitioning ? 'transitioning' : '',
                ].join(' ')
            }
        >
            {/*
              * Wrapper and badge are divs, not spans, on purpose. The collapsed
              * sidebar hides every span it contains (`.AppSidebarNav__container
              * .hidden span { display: none }`) to drop the nav labels — which
              * would take the icon and its unread count with it. The label below
              * IS a span, because that one should hide.
              */}
            <div className="notif-navlink-icon">
                <NotificationsNoneIcon />
                {unreadCount > 0 && (
                    <div className="notif-navlink-badge">
                        {unreadCount > 99 ? '99+' : unreadCount}
                    </div>
                )}
            </div>
            <span>Notifications</span>
        </NavLink>
    )
}
